import { Toaster as Sonner } from 'sonner'
import { useTheme } from '@/providers/ThemeProvider'
import { useMediaQuery } from '@/hooks/use-media-query'

/**
 * Configured Sonner Toaster — SWIM branded.
 *
 * Light: sand-200 background, slate-800 graphite text, sand-400 border
 * Dark:  slate-800 graphite background, sand-200 cream text, slate-700 border, shadow
 *
 * Colors are driven by CSS variables in globals.css — [data-sonner-toaster][data-theme=*]
 * richColors is intentionally off — we don't want Sonner's green/red/yellow palette.
 *
 * Desktop: shows X close button. Mobile: hidden — swipe in any direction to dismiss.
 *
 * Mount once in main.tsx inside ThemeProvider — toasts survive route changes.
 */
export function Toaster() {
  const { theme } = useTheme()
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  return (
    <Sonner
      theme={theme}
      position="bottom-center"
      expand={false}
      closeButton={isDesktop}
      swipeDirections={['top', 'right', 'bottom', 'left']}
      toastOptions={{
        classNames: {
          toast: 'font-sans text-sm !shadow-lg',
          title: '!font-medium !text-center',
          description: '!text-[var(--normal-fg)] !opacity-70',
          closeButton: '!border-[var(--normal-border-color)]',
        },
      }}
    />
  )
}
